import ReportCardSkeleton from "./reportCardSkeleton";

export default ReportCardSkeleton;
